export type OrderStatus = OrderStatusEnum;

export enum OrderStatusEnum {
  PENDING = 'PENDING',
  EXECUTED = 'EXECUTED',
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED'
}
